// removed by extract-text-webpack-plugin
module.exports = {"PhoneNumberInput":"PhoneNumberInput","PhoneNumberInput--country-list":"PhoneNumberInput--country-list","selectCountry":"selectCountry","school-name-input":"school-name-input","PhoneNumberInput--holder":"PhoneNumberInput--holder","PhoneNumberInput--flag":"PhoneNumberInput--flag","name":"name","code":"code","register-phone":"register-phone"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Fields/PhoneNumber/PhoneNumberInput.scss
// module id = eUcS
// module chunks = 0